/* movimiento-pro.js · /diseno-web · v1 (2026-10-18)
   Motivo: Esteban pidió que las webs nuevas tengan «esos movimientos y esa fluidez» de la referencia
   destilada en referencias/holo-movimiento.md. Aquí está el SISTEMA reescrito desde cero (ni una línea
   del sitio de referencia): módulos activables con atributos data-mp="…", sin dependencias.

   CÓMO SE USA
     <link rel="stylesheet" href="movimiento-pro.css">          (obligatorio: estados de los módulos)
     <link rel="stylesheet" href="tema-holo-fluido.css">        (opcional: estética, va DESPUÉS del tema)
     <script src="movimiento-pro.js" defer></script>
   Scroll suave opcional (Lenis 1.3.4 por CDN, solo ratón/trackpad): <html data-mp-scroll="suave">.
   La referencia NO lo usa (scroll nativo + muelles sobre el progreso): por defecto, apagado.

   MÓDULOS (data-mp="…")                       → receta y función de venta en holo-movimiento.md §4
     revelar · grupo        aparición al entrar (24 px, 0,6 s) y escalonado de hijos (80 ms)
     letras                 el texto «se escribe» con el scroll, letra a letra (opción: destello de color)
     escena                 storytelling fijo (sticky): --p, pasos [data-mp-paso] y cambio de tono por tramo
     pila                   tarjetas que se apilan y encogen al hacer scroll
     contador               cifra que sube al verse (NUNCA en precios: se ignora dentro de .precio/.plan…)
     barra                  cifra + barra ligadas al scroll
     cinta                  marquesina infinita (se pausa fuera de pantalla y al pasar el ratón)
     rotador                palabra que gira en 3D (rotateX) cada 2,4 s
     anillo                 carrusel 3D en anillo que gira solo
     trazo                  secuencia: flechas SVG que se dibujan y piezas que aparecen por orden
     despliegue             tarjetas que se expanden (flex-grow) al pasar/pulsar
     cabecera               cabecera que se compacta al bajar y cambia de tono sobre secciones oscuras
     magnetico              botón que sigue un poco al cursor (solo ratón)
     parallax               capa que se desplaza más lenta/rápida que el scroll
     flotar                 etiquetas que flotan en bucle lento
     escribir               máquina de escribir decorativa (placeholder)
     video-vista            vídeo que solo se reproduce mientras se ve
     cupon                  aviso de cupón REAL (ver holo-movimiento.md §7 y líneas rojas)

   REGLAS QUE EL CÓDIGO HACE CUMPLIR
     · prefers-reduced-motion: todo queda en su estado final, legible y quieto (los ligados al scroll también).
     · Nada se anima dentro de .precio, [data-precio], .plan, .planes, .legal, [data-legal], .consentimiento.
     · Nada se oculta en el hero ni lo que ya está en pantalla al cargar (LCP).
     · Solo se anima transform / opacity / clip-path / color (sin layout), con un único bucle rAF que se duerme.
     · Sin JS la página está completa: cada módulo parte del HTML final. */
(function () {
  'use strict';
  var d = document, raiz = d.documentElement, W = window;
  var mm = function (q) { return W.matchMedia ? W.matchMedia(q).matches : false; };
  var reducir = mm('(prefers-reduced-motion: reduce)');
  var fino = mm('(hover: hover) and (pointer: fine)');
  var PROHIBIDO = '.precio,[data-precio],.plan,.planes,.legal,[data-legal],.consentimiento';
  var PALETA = ['#4F7FE0', '#9A6BE0', '#D04FB8', '#F0457E', '#F2602E', '#F08A2E'];

  function todos(sel, ctx) { return Array.prototype.slice.call((ctx || d).querySelectorAll(sel)); }
  function num(v, def) { var n = parseFloat(v); return isNaN(n) ? def : n; }
  function at(el, n, def) { var v = el.getAttribute('data-mp-' + n); return v == null ? def : v; }
  function clamp(x, a, b) { return Math.min(b, Math.max(a, x)); }
  function tramo(p, a, b) { return b === a ? (p >= b ? 1 : 0) : clamp((p - a) / (b - a), 0, 1); }
  function prohibido(el) { return !!(el.closest && el.closest(PROHIBIDO)); }
  function enHero(el) { return !!(el.closest && el.closest('.hero,[data-mp-no]')); }
  function leer(k) { try { return localStorage.getItem(k); } catch (e) { try { return sessionStorage.getItem(k); } catch (e2) { return null; } } }
  function guardar(k, v) { try { localStorage.setItem(k, v); } catch (e) { try { sessionStorage.setItem(k, v); } catch (e2) {} } }
  function visto(el, cb, opciones) {
    if (!('IntersectionObserver' in W)) { cb(el); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); cb(e.target); } });
    }, opciones || { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    io.observe(el);
  }
  function enPantalla(el, cb, margen) { // cb(true/false) cada vez que entra o sale (para pausar bucles)
    if (!('IntersectionObserver' in W)) { cb(true); return; }
    new IntersectionObserver(function (es) { es.forEach(function (e) { cb(e.isIntersecting); }); },
      { rootMargin: margen || '100px 0px' }).observe(el);
  }

  raiz.classList.add('mp-js');
  if (reducir) raiz.classList.add('mp-quieto');

  /* ------------------------------------------------------------------
     MOTOR DE PROGRESO DE SCROLL (un solo rAF; se duerme al asentarse)
     inicio/fin = "elemento ventana" (p. ej. "start 0.9" = el borde superior del elemento
     al 90 % de la altura de la ventana). 0 → 1 entre las dos posiciones.
     suave = λ de un muelle amortiguado (≈ 1 − e^(−λ·dt)); 0 = sin suavizado.
     ------------------------------------------------------------------ */
  var POS = { start: 0, center: 0.5, end: 1 };
  function par(s) { var a = String(s).split(' '); return [POS[a[0]] != null ? POS[a[0]] : num(a[0], 0), POS[a[1]] != null ? POS[a[1]] : num(a[1], 0)]; }
  function progreso(el, ini, fin) {
    var r = el.getBoundingClientRect(), vh = W.innerHeight;
    var c = vh * ini[1] - r.height * ini[0], f = vh * fin[1] - r.height * fin[0];
    return c === f ? 0 : clamp((c - r.top) / (c - f), 0, 1);
  }
  var pistas = [], corriendo = false, ultimo = 0;
  function pista(el, inicio, fin, suave, fn) {
    var t = { el: el, ini: par(inicio), fin: par(fin), suave: suave, fn: fn, x: 0, obj: 0, activa: true, nueva: true };
    if (reducir) { fn(1); return t; }
    t.obj = t.x = progreso(el, t.ini, t.fin); fn(t.x); t.nueva = false;
    pistas.push(t);
    enPantalla(el, function (dentro) {
      t.activa = dentro;
      if (!dentro) { t.obj = t.x = progreso(el, t.ini, t.fin); fn(t.x); } // al salir, queda en su estado exacto
      else medir();
    }, '30% 0px');
    return t;
  }
  function medir() { for (var i = 0; i < pistas.length; i++) if (pistas[i].activa) pistas[i].obj = progreso(pistas[i].el, pistas[i].ini, pistas[i].fin); arrancar(); }
  function arrancar() { if (!corriendo && pistas.length) { corriendo = true; ultimo = performance.now(); requestAnimationFrame(paso); } }
  function paso(ahora) {
    // (el sello del rAF puede ser ANTERIOR a performance.now() de arrancar(): dt negativo daría un muelle
    // que se pasa de rango; por eso dt ≥ 0 y el valor nunca sale del tramo entre x y el objetivo)
    var dt = clamp((ahora - ultimo) / 1000, 0, 0.05), vivo = false; ultimo = Math.max(ahora, ultimo);
    for (var i = 0; i < pistas.length; i++) {
      var t = pistas[i]; if (!t.activa) continue;
      var k = t.suave ? 1 - Math.exp(-dt * t.suave) : 1, nx = clamp(t.x + (t.obj - t.x) * k, Math.min(t.x, t.obj), Math.max(t.x, t.obj));
      if (Math.abs(t.obj - nx) < 0.0004) nx = t.obj; else vivo = true;
      if (nx !== t.x) { t.x = nx; t.fn(nx); }
    }
    if (vivo) requestAnimationFrame(paso); else corriendo = false;
  }
  W.addEventListener('scroll', medir, { passive: true });
  W.addEventListener('resize', medir);

  /* ---------------- 0 · Scroll suave opcional (Lenis) ---------------- */
  if (!reducir && fino && raiz.getAttribute('data-mp-scroll') === 'suave' && !W.lenisPagina) {
    var s = d.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/lenis@1.3.4/dist/lenis.min.js'; s.async = true;
    s.onload = function () {
      if (!W.Lenis) return;
      raiz.style.scrollBehavior = 'auto';
      W.lenisPagina = new W.Lenis({ lerp: 0.1, smoothWheel: true, syncTouch: false, autoRaf: true,
        prevent: function (n) { return !!(n.closest && n.closest('dialog,[data-lenis-prevent],[data-mp="cupon"]')); } });
    };
    d.head.appendChild(s);
  }

  /* ---------------- 1 · revelar / grupo ---------------- */
  var alto0 = W.innerHeight;
  function preparaRevelar(el, retraso) {
    if (enHero(el) || prohibido(el) || el.getBoundingClientRect().top < alto0 * 0.9) return;
    el.classList.add('mp-oculto');
    el.style.setProperty('--mp-retraso', (retraso || num(at(el, 'retraso', 0), 0)) + 'ms');
    var y = at(el, 'y', null); if (y != null) el.style.setProperty('--mp-y', y + 'px');
    if (reducir) { el.classList.add('mp-visto'); return; }
    visto(el, function (e) { e.classList.add('mp-visto'); }, { rootMargin: '0px 0px -80px 0px', threshold: 0 });
  }
  todos('[data-mp="revelar"]').forEach(function (el) { preparaRevelar(el); });
  todos('[data-mp="grupo"]').forEach(function (g) {
    var pasoMs = num(at(g, 'paso', 80), 80);
    Array.prototype.forEach.call(g.children, function (h, i) { preparaRevelar(h, Math.min(i, 6) * pasoMs); });
  });

  /* ---------------- 2 · letras (texto que se escribe con el scroll) ---------------- */
  todos('[data-mp="letras"]').forEach(function (el) {
    if (prohibido(el)) return;
    var porPalabra = at(el, 'unidad', 'letra') === 'palabra', destello = at(el, 'destello', 'no') === 'si';
    var texto = el.textContent.replace(/\s+/g, ' ').trim();
    if (!el.getAttribute('aria-label')) el.setAttribute('aria-label', texto);
    var piezas = [], frag = d.createDocumentFragment(), ci = 0;
    (function recorre(origen, destino, enfasis) {
      Array.prototype.forEach.call(origen.childNodes, function (n) {
        if (n.nodeType === 3) {
          n.textContent.split(/(\s+)/).forEach(function (tok) {
            if (!tok) return;
            if (/^\s+$/.test(tok)) { destino.appendChild(d.createTextNode(' ')); return; }
            var pal = d.createElement('span'); pal.className = 'mp-pal'; pal.setAttribute('aria-hidden', 'true');
            if (porPalabra) { pal.textContent = tok; pal._color = enfasis ? PALETA[ci++ % PALETA.length] : null; piezas.push(pal); }
            else Array.prototype.forEach.call(tok, function (ch) {
              var c = d.createElement('span'); c.className = 'mp-car'; c.textContent = ch;
              c._color = enfasis ? PALETA[ci++ % PALETA.length] : null; piezas.push(c); pal.appendChild(c);
            });
            destino.appendChild(pal);
          });
        } else if (n.nodeType === 1) {
          var copia = n.cloneNode(false); copia.removeAttribute && copia.removeAttribute('id');
          destino.appendChild(copia); recorre(n, copia, enfasis || /^(EM|MARK|STRONG)$/.test(n.tagName));
        }
      });
    })(el, frag, false);
    el.textContent = ''; el.appendChild(frag); el.classList.add('mp-letras');
    var encendidas = 0, total = piezas.length;
    function pinta(p) {
      var n = clamp(Math.round(p * total), 0, total);
      for (var i = Math.min(n, encendidas); i < Math.max(n, encendidas); i++) {
        var on = i < n, c = piezas[i]; c.classList.toggle('on', on);
        if (on && c._color) c.style.color = c._color;
        else if (on && destello && !reducir) { c.style.color = PALETA[i % PALETA.length]; (function (x) { setTimeout(function () { x.style.color = ''; }, 380); })(c); }
        else if (!on) c.style.color = '';
      }
      encendidas = n;
    }
    pista(el, at(el, 'inicio', 'start 0.92'), at(el, 'fin', 'start 0.4'), num(at(el, 'suave', 9), 9), pinta);
  });

  /* ---------------- 3 · escena (storytelling fijo + cambio de tono) ---------------- */
  todos('[data-mp="escena"]').forEach(function (sec) {
    var alto = num(at(sec, 'alto', 170), 170);
    var tono = String(at(sec, 'tono', '')).split(' ').map(Number);
    var pasos = todos('[data-mp-paso]', sec).map(function (p) { var v = p.getAttribute('data-mp-paso').split(' ').map(Number); return { el: p, a: v[0], b: v.length > 1 ? v[1] : 2 }; });
    if (!reducir) { sec.style.height = alto + 'vh'; sec.style.height = alto + 'svh'; }
    sec.classList.add('mp-escena');
    pista(sec, 'start start', 'end end', num(at(sec, 'suave', 12), 12), function (p) {
      sec.style.setProperty('--p', p.toFixed(4));
      if (tono.length === 2 && !isNaN(tono[0])) { var q = tramo(p, tono[0], tono[1]); sec.style.setProperty('--q', q.toFixed(4)); sec.classList.toggle('mp-tono-b', q > 0.5);
        if (sec.hasAttribute('data-tono')) sec.setAttribute('data-tono', q > 0.5 ? 'claro' : 'oscuro'); } // la cabecera lo lee
      pasos.forEach(function (s) { s.el.classList.toggle('activo', p >= s.a && p < s.b); });
    });
  });

  /* ---------------- 4 · pila (tarjetas que se apilan) ---------------- */
  todos('[data-mp="pila"]').forEach(function (pl) {
    var tarjetas = Array.prototype.slice.call(pl.children).filter(function (c) { return !c.hasAttribute('data-mp-no'); });
    var n = tarjetas.length; if (n < 2) return;
    pl.classList.add('mp-pila');
    function iguala() { // misma altura para que la pila se vea ordenada
      tarjetas.forEach(function (t) { t.style.minHeight = ''; });
      var m = 0; tarjetas.forEach(function (t) { m = Math.max(m, t.offsetHeight); });
      tarjetas.forEach(function (t) { t.style.minHeight = m + 'px'; });
    }
    iguala(); W.addEventListener('resize', iguala);
    tarjetas.forEach(function (t, i) { t.style.zIndex = i + 1; });
    pista(pl, 'start start', 'end end', num(at(pl, 'suave', 14), 14), function (p) {
      tarjetas.forEach(function (t, i) {
        var minimo = Math.max(0.85, 1 - 0.05 * (n - 1 - i));
        var s = reducir ? 1 : 1 - (1 - minimo) * tramo(p, i / n, 1);
        t.style.transform = 'scale(' + s.toFixed(4) + ')';
      });
    });
  });

  /* ---------------- 5 · contador (nunca precios) ---------------- */
  todos('[data-mp="contador"]').forEach(function (el) {
    if (prohibido(el) || reducir) return;
    var hasta = num(at(el, 'hasta', el.textContent), NaN); if (isNaN(hasta)) return;
    var dec = (String(at(el, 'hasta', '')).split('.')[1] || '').length, suf = at(el, 'sufijo', ''), pre = at(el, 'prefijo', '');
    var fmt = function (v) { return pre + v.toLocaleString(raiz.lang || 'es', { minimumFractionDigits: dec, maximumFractionDigits: dec }) + suf; };
    el.setAttribute('aria-label', fmt(hasta));
    visto(el, function () {
      var t0 = performance.now(), dur = num(at(el, 'dur', 1400), 1400);
      (function f(ahora) {
        var k = Math.min((ahora - t0) / dur, 1), e = k === 1 ? 1 : 1 - Math.pow(2, -10 * k); // expo-out
        el.textContent = fmt(hasta * e); if (k < 1) requestAnimationFrame(f);
      })(t0);
    }, { rootMargin: '0px 0px -60px 0px', threshold: 0 });
    el.textContent = fmt(0);
  });

  /* ---------------- 6 · barra (cifra + barra ligadas al scroll) ---------------- */
  todos('[data-mp="barra"]').forEach(function (el) {
    if (prohibido(el)) return;
    var hasta = num(at(el, 'hasta', 100), 100), cifra = el.querySelector('[data-mp-cifra]'), rel = el.querySelector('[data-mp-relleno]');
    pista(el, at(el, 'inicio', 'start 0.95'), at(el, 'fin', 'start 0.45'), num(at(el, 'suave', 10), 10), function (p) {
      if (cifra) cifra.textContent = Math.round(p * hasta) + (at(el, 'sufijo', '%'));
      if (rel) rel.style.transform = 'scaleX(' + (p * hasta / 100).toFixed(4) + ')';
    });
  });

  /* ---------------- 7 · cinta (marquesina) ---------------- */
  todos('[data-mp="cinta"]').forEach(function (el) {
    el.classList.add('mp-cinta');
    el.style.setProperty('--mp-dur', num(at(el, 'dur', 32), 32) + 's');
    if (reducir) return;
    var pista2 = d.createElement('div'); pista2.className = 'mp-cinta-pista';
    while (el.firstChild) pista2.appendChild(el.firstChild);
    Array.prototype.slice.call(pista2.children).forEach(function (c) {
      var k = c.cloneNode(true); k.setAttribute('aria-hidden', 'true'); k.setAttribute('inert', '');
      todos('a,button,input', k).forEach(function (x) { x.setAttribute('tabindex', '-1'); }); pista2.appendChild(k);
    });
    el.appendChild(pista2);
    enPantalla(el, function (v) { el.classList.toggle('mp-pausa', !v); });
  });

  /* ---------------- 8 · rotador (palabra que gira en 3D) ---------------- */
  todos('[data-mp="rotador"]').forEach(function (el) {
    var pals = String(at(el, 'palabras', el.textContent)).split('|').map(function (s) { return s.trim(); }).filter(Boolean);
    if (pals.length < 2) return;
    var sr = d.createElement('span'); sr.className = 'mp-sr'; sr.textContent = pals.join(', ');
    var vis = d.createElement('span'); vis.className = 'mp-rotador'; vis.setAttribute('aria-hidden', 'true');
    var medida = d.createElement('span'); medida.className = 'mp-rotador-medida';
    el.textContent = ''; el.appendChild(sr); el.appendChild(vis); vis.appendChild(medida);
    var i = 0, actual = null;
    // Ancho fijo = la palabra más larga: cambiar el ancho movería el resto de la línea (CLS). La referencia
    // anima el ancho; aquí no, para no provocar saltos de maquetación.
    var larga = pals.reduce(function (a, b) { return b.length > a.length ? b : a; }, '');
    medida.textContent = larga; vis.style.width = medida.offsetWidth + 'px';
    function pon(txt, entra) {
      var s2 = d.createElement('span'); s2.className = 'mp-rotador-pal' + (entra ? ' entra' : ''); s2.textContent = txt;
      vis.appendChild(s2);
      if (entra) requestAnimationFrame(function () { requestAnimationFrame(function () { s2.classList.remove('entra'); }); });
      if (actual) { var viejo = actual; viejo.classList.add('sale'); setTimeout(function () { viejo.remove(); }, 520); }
      actual = s2;
    }
    pon(pals[0], false);
    if (reducir) return;
    var dentro = false; enPantalla(el, function (v) { dentro = v; });
    setInterval(function () { if (!dentro || d.hidden) return; i = (i + 1) % pals.length; pon(pals[i], true); }, num(at(el, 'cada', 2400), 2400));
  });

  /* ---------------- 9 · anillo (carrusel 3D que gira solo) ---------------- */
  todos('[data-mp="anillo"]').forEach(function (el) {
    var items = Array.prototype.slice.call(el.children); if (items.length < 3) return;
    el.classList.add('mp-anillo');
    if (reducir) return; // en reducido: fila con scroll horizontal (CSS)
    var aro = d.createElement('div'); aro.className = 'mp-anillo-aro';
    items.forEach(function (it) { aro.appendChild(it); });
    var minimo = num(at(el, 'minimo', 10), 10), k = 0;
    while (aro.children.length < minimo) { var c = items[k++ % items.length].cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.setAttribute('inert', ''); aro.appendChild(c); }
    el.appendChild(aro);
    var ang = 0, n = aro.children.length, vuelta = num(at(el, 'vuelta', 48), 48), radio = 0, dentro = false, encima = false;
    function coloca() {
      var w = aro.children[0].offsetWidth || 220; radio = Math.round((w / 2 + 14) / Math.tan(Math.PI / n));
      Array.prototype.forEach.call(aro.children, function (c, i) { c.style.transform = 'rotateY(' + (i * 360 / n) + 'deg) translateZ(' + radio + 'px)'; });
    }
    coloca(); W.addEventListener('resize', coloca);
    el.addEventListener('pointerenter', function () { encima = true; });
    el.addEventListener('pointerleave', function () { encima = false; });
    var t = performance.now();
    (function giro(ahora) {
      var dt = clamp((ahora - t) / 1000, 0, 0.05); t = Math.max(ahora, t);
      if (dentro && !d.hidden) { ang = (ang + (encima ? 0.25 : 1) * 360 / vuelta * dt) % 360; aro.style.transform = 'translateZ(' + (-radio) + 'px) rotateY(' + (-ang) + 'deg)'; }
      requestAnimationFrame(giro);
    })(t);
    enPantalla(el, function (v) { dentro = v; });
  });

  /* ---------------- 10 · trazo (secuencia de flechas y piezas) ---------------- */
  todos('[data-mp="trazo"]').forEach(function (el) {
    var pasoMs = num(at(el, 'paso', 450), 450);
    var piezas = todos('[data-mp-orden]', el).sort(function (a, b) { return num(a.getAttribute('data-mp-orden'), 0) - num(b.getAttribute('data-mp-orden'), 0); });
    if (reducir) return;
    piezas.forEach(function (p) {
      var o = num(p.getAttribute('data-mp-orden'), 0), retraso = o * pasoMs;
      if (p.tagName.toLowerCase() === 'path' && p.getTotalLength) {
        var L = Math.ceil(p.getTotalLength()); p.style.strokeDasharray = L; p.style.strokeDashoffset = L;
        p.style.transition = 'stroke-dashoffset 600ms cubic-bezier(.65,0,.35,1) ' + (retraso + pasoMs * 0.75) + 'ms';
        p.classList.add('mp-trazo-linea');
      } else { p.classList.add('mp-pieza'); p.style.setProperty('--mp-retraso', retraso + 'ms'); }
    });
    visto(el, function () { el.classList.add('mp-visto'); piezas.forEach(function (p) { if (p.classList.contains('mp-trazo-linea')) p.style.strokeDashoffset = 0; }); },
      { rootMargin: '0px 0px -80px 0px', threshold: 0.15 });
  });

  /* ---------------- 11 · despliegue (tarjetas que se expanden) ---------------- */
  todos('[data-mp="despliegue"]').forEach(function (el) {
    var hijos = Array.prototype.slice.call(el.children); el.classList.add('mp-despliegue');
    function activa(h) { hijos.forEach(function (x) { x.classList.toggle('activo', x === h); x.setAttribute('aria-expanded', x === h ? 'true' : 'false'); }); }
    hijos.forEach(function (h) {
      if (!h.hasAttribute('tabindex')) h.setAttribute('tabindex', '0');
      h.setAttribute('role', 'button');
      h.addEventListener('click', function () { activa(h); });
      h.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activa(h); } });
      if (fino) h.addEventListener('pointerenter', function () { activa(h); });
    });
    activa(hijos[0]);
  });

  /* ---------------- 12 · cabecera (compacta al bajar + tono de lo que tiene debajo) ---------------- */
  todos('[data-mp="cabecera"]').forEach(function (hd) {
    var umbral = num(at(hd, 'umbral', 60), 60), pend = false;
    function mira() {
      pend = false;
      hd.classList.toggle('mp-compacta', W.scrollY > umbral);
      var r = hd.getBoundingClientRect(), x = W.innerWidth / 2, y = r.bottom + 2;
      hd.style.visibility = 'hidden'; var bajo = d.elementFromPoint(x, Math.min(y, W.innerHeight - 1)); hd.style.visibility = '';
      var s = bajo && bajo.closest && bajo.closest('[data-tono]');
      hd.setAttribute('data-tono-debajo', s ? s.getAttribute('data-tono') : 'claro');
    }
    W.addEventListener('scroll', function () { if (!pend) { pend = true; requestAnimationFrame(mira); } }, { passive: true });
    mira();
  });

  /* ---------------- 13 · magnetico (solo ratón) ---------------- */
  if (fino && !reducir) todos('[data-mp="magnetico"]').forEach(function (b) {
    var fuerza = num(at(b, 'fuerza', 0.3), 0.3);
    b.classList.add('mp-magnetico');
    b.addEventListener('pointermove', function (e) {
      var r = b.getBoundingClientRect(), dx = e.clientX - (r.left + r.width / 2), dy = e.clientY - (r.top + r.height / 2);
      b.style.transform = 'translate(' + clamp(dx * fuerza, -10, 10).toFixed(1) + 'px,' + clamp(dy * fuerza, -8, 8).toFixed(1) + 'px)';
    });
    b.addEventListener('pointerleave', function () { b.style.transform = ''; });
  });

  /* ---------------- 14 · parallax de capas ---------------- */
  todos('[data-mp="parallax"]').forEach(function (el) {
    if (prohibido(el)) return; // capas decorativas; nunca el texto del hero ni precios
    var vel = num(at(el, 'vel', 0.15), 0.15);
    pista(el, 'start end', 'end start', 0, function (p) {
      var y = clamp((0.5 - p) * vel * W.innerHeight, -90, 90);
      el.style.transform = reducir ? '' : 'translate3d(0,' + y.toFixed(1) + 'px,0)';
    });
  });

  /* ---------------- 15 · flotar (etiquetas en bucle lento) ---------------- */
  todos('[data-mp="flotar"]').forEach(function (el, i) {
    el.classList.add('mp-flota');
    el.style.setProperty('--mp-dur', num(at(el, 'dur', 7 + (i % 4) * 1.3), 8) + 's');
    el.style.setProperty('--mp-retraso', (-i * 1.7) + 's');
  });

  /* ---------------- 16 · escribir (máquina de escribir decorativa) ---------------- */
  todos('[data-mp="escribir"]').forEach(function (el) {
    var textos = String(at(el, 'textos', el.textContent)).split('|').filter(Boolean); if (!textos.length) return;
    var sr = d.createElement('span'); sr.className = 'mp-sr'; sr.textContent = textos[0];
    var vis = d.createElement('span'); vis.setAttribute('aria-hidden', 'true'); vis.className = 'mp-escribe';
    el.textContent = ''; el.appendChild(sr); el.appendChild(vis);
    if (reducir) { vis.textContent = textos[0]; return; }
    // Reserva el alto del texto más largo: si al escribir salta de línea, lo de abajo se movería (CLS)
    function reserva() {
      var larga = textos.reduce(function (a, b) { return b.length > a.length ? b : a; }, ''), antes = vis.textContent;
      el.style.display = 'inline-block'; el.style.width = '100%'; el.style.minHeight = '';
      vis.textContent = larga; el.style.minHeight = el.offsetHeight + 'px'; vis.textContent = antes;
    }
    reserva(); W.addEventListener('resize', reserva);
    var i = 0, dentro = false; enPantalla(el, function (v) { dentro = v; });
    function espera(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
    (async function bucle() {
      for (;;) {
        var t = textos[i % textos.length];
        while (!dentro || d.hidden) await espera(400);
        for (var k = 1; k <= t.length; k++) { vis.textContent = t.slice(0, k); await espera(42 + Math.random() * 40); }
        await espera(1700);
        if (textos.length === 1) return;
        for (var j = t.length; j >= 0; j--) { vis.textContent = t.slice(0, j); await espera(22); }
        i++; await espera(300);
      }
    })();
  });

  /* ---------------- 17 · video-vista ---------------- */
  todos('video[data-mp="video-vista"]').forEach(function (v) {
    v.muted = true; v.setAttribute('playsinline', ''); v.setAttribute('muted', '');
    if (reducir) { v.removeAttribute('autoplay'); v.setAttribute('controls', ''); return; }
    enPantalla(v, function (dentro) {
      if (dentro) { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause();
    }, '0px');
  });

  /* ---------------- 18 · cupon (aviso de cupón REAL) ----------------
     Líneas rojas que el código hace cumplir:
       · sin data-codigo o sin data-verificado (fecha en que se comprobó en Shopify) NO se muestra;
       · si data-caduca (AAAA-MM-DD) ya pasó, NO se muestra; la fecha se enseña tal cual, sin cuenta atrás;
       · no es modal: no hay velo, no bloquea el scroll ni la compra, no roba el foco;
       · espera a que no haya aviso de cookies visible y a que la zona de compra no esté en pantalla;
       · se cierra con la X o Esc y no vuelve (localStorage); al aplicarlo, tampoco. */
  todos('[data-mp="cupon"]').forEach(function (el) {
    var codigo = el.getAttribute('data-codigo'), verificado = el.getAttribute('data-verificado');
    if (!codigo || !verificado) { console.warn('[movimiento-pro] Aviso de cupón sin data-codigo o data-verificado: no se muestra (solo descuentos reales de Shopify).'); return; }
    var caduca = el.getAttribute('data-caduca');
    if (caduca && new Date(caduca + 'T23:59:59') < new Date()) return;
    var clave = 'mp-cupon:' + (el.getAttribute('data-clave') || codigo);
    if (leer(clave)) return;
    var retraso = num(el.getAttribute('data-retraso'), 8) * 1000, umbral = num(el.getAttribute('data-umbral'), 0.2);
    var COOKIES = el.getAttribute('data-cookies') || '#shopify-pc__banner,.shopify-pc__banner__dialog,[data-cookies],#cookie-banner,.cookie-banner,.cc-window,#onetrust-banner-sdk';
    var COMPRA = el.getAttribute('data-zona-compra') || '#comprar,[data-mp-compra]';
    var TRAS = el.getAttribute('data-tras') || '.hero,.portada,[data-mp-portada]'; // aparece cuando el hero ya pasó
    var movil = mm('(max-width: 640px)');
    var listo = false, t0 = Date.now();
    function visible(sel) {
      return todos(sel).some(function (x) { var r = x.getBoundingClientRect(), c = getComputedStyle(x); return r.width > 0 && r.height > 0 && c.visibility !== 'hidden' && c.display !== 'none' && +c.opacity > 0.05 && r.bottom > 0 && r.top < W.innerHeight; });
    }
    function fraccion() { var h = raiz.scrollHeight - W.innerHeight; return h > 0 ? W.scrollY / h : 1; }
    function abajoLibre() { // si hay barra de compra fija que se solaparía, el aviso se coloca encima de ella
      var fija = d.querySelector('.fija,[data-mp-barra-compra]'), abajo = 20;
      if (fija) { var r = fija.getBoundingClientRect(), a = el.getBoundingClientRect(); if (r.height && r.top < W.innerHeight && !(r.right < a.left || r.left > a.right)) abajo = W.innerHeight - r.top + 12; }
      el.style.setProperty('--cupon-abajo', abajo + 'px');
    }
    function intenta() {
      if (listo) return;
      var hero = d.querySelector(TRAS), heroVisible = hero && hero.getBoundingClientRect().bottom > 0;
      if (Date.now() - t0 < retraso || fraccion() < umbral || heroVisible || visible(COOKIES) || visible(COMPRA)) { setTimeout(intenta, 1200); return; }
      listo = true; abre();
    }
    function abre() {
      el.hidden = false; el.classList.add('mp-cupon');
      if (movil) el.classList.add('plegado'); // en móvil entra plegado (una línea) y se despliega al tocar
      abajoLibre();
      W.addEventListener('resize', abajoLibre); W.addEventListener('scroll', abajoLibre, { passive: true });
      requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('abierto'); }); });
      if (!movil) preparaRasca();
    }
    todos('[data-cupon-abrir]', el).forEach(function (b) {
      b.addEventListener('click', function () { el.classList.remove('plegado'); b.setAttribute('aria-expanded', 'true'); abajoLibre(); preparaRasca(); });
    });
    function cierra(motivo) {
      guardar(clave, motivo + ' ' + new Date().toISOString().slice(0, 10));
      el.classList.remove('abierto'); el.classList.add('cerrando');
      setTimeout(function () { el.hidden = true; el.classList.remove('cerrando'); }, reducir ? 0 : 260);
    }
    todos('[data-cupon-cerrar]', el).forEach(function (b) { b.addEventListener('click', function () { cierra('cerrado'); }); });
    el.addEventListener('keydown', function (e) { if (e.key === 'Escape') cierra('cerrado'); });
    todos('[data-cupon-aplicar]', el).forEach(function (a) { a.addEventListener('click', function () { guardar(clave, 'aplicado ' + new Date().toISOString().slice(0, 10)); }); });
    var estado = el.querySelector('[data-cupon-estado]');
    todos('[data-cupon-copiar]', el).forEach(function (b) {
      b.addEventListener('click', function () {
        var ok = function () { if (estado) estado.textContent = b.getAttribute('data-copiado') || 'Código copiado'; b.classList.add('copiado'); setTimeout(function () { b.classList.remove('copiado'); }, 1600); };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(codigo).then(ok, ok); else ok();
      });
    });
    function revela() {
      if (el.classList.contains('revelado')) return;
      el.classList.add('revelado');
      if (estado) estado.textContent = (el.getAttribute('data-texto-revelado') || 'Tu código es') + ' ' + codigo;
      if (!reducir) confeti();
    }
    function confeti() {
      var caja = el.querySelector('.cupon-tarjeta') || el;
      for (var i = 0; i < 14; i++) {
        var p = d.createElement('i'); p.className = 'mp-confeti'; p.setAttribute('aria-hidden', 'true');
        p.style.setProperty('--x', (Math.random() * 2 - 1) * 120 + 'px'); p.style.setProperty('--y', (-40 - Math.random() * 70) + 'px');
        p.style.setProperty('--g', (Math.random() * 540 - 270) + 'deg'); p.style.background = PALETA[i % PALETA.length];
        caja.appendChild(p); (function (x) { setTimeout(function () { x.remove(); }, 1300); })(p);
      }
    }
    todos('[data-cupon-revelar]', el).forEach(function (b) { b.addEventListener('click', revela); });
    var rascaLista = false;
    function preparaRasca() {
      if (rascaLista) return; rascaLista = true;
      var lienzo = el.querySelector('canvas[data-cupon-rascar]');
      if (!lienzo || reducir) { revelaSinRascar(); return; }
      var r = lienzo.getBoundingClientRect(), dpr = Math.min(W.devicePixelRatio || 1, 2);
      lienzo.width = Math.round(r.width * dpr); lienzo.height = Math.round(r.height * dpr);
      var cx = lienzo.getContext('2d'); cx.scale(dpr, dpr);
      var g = cx.createLinearGradient(0, 0, r.width, r.height);
      PALETA.forEach(function (c, i) { g.addColorStop(i / (PALETA.length - 1), c); });
      cx.fillStyle = g; cx.fillRect(0, 0, r.width, r.height);
      cx.fillStyle = 'rgba(255,255,255,.92)'; cx.font = '700 13px system-ui,sans-serif'; cx.textAlign = 'center'; cx.textBaseline = 'middle';
      cx.fillText(lienzo.getAttribute('data-texto') || 'RASCA AQUÍ', r.width / 2, r.height / 2);
      cx.globalCompositeOperation = 'destination-out'; cx.lineCap = 'round'; cx.lineJoin = 'round'; cx.lineWidth = 34;
      var pulsado = false, ult = null, trazos = 0;
      function pos(e) { var b = lienzo.getBoundingClientRect(); return [e.clientX - b.left, e.clientY - b.top]; }
      lienzo.addEventListener('pointerdown', function (e) { pulsado = true; ult = pos(e); lienzo.setPointerCapture && lienzo.setPointerCapture(e.pointerId); });
      lienzo.addEventListener('pointermove', function (e) {
        if (!pulsado) return; var p = pos(e);
        cx.beginPath(); cx.moveTo(ult[0], ult[1]); cx.lineTo(p[0], p[1]); cx.stroke(); ult = p;
        if (++trazos % 12 === 0 && limpio() > 0.45) { lienzo.classList.add('fuera'); revela(); }
      });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (t) { lienzo.addEventListener(t, function () { pulsado = false; }); });
      function limpio() {
        var dat = cx.getImageData(0, 0, lienzo.width, lienzo.height).data, vacio = 0, total = 0;
        for (var i = 3; i < dat.length; i += 64) { total++; if (dat[i] < 20) vacio++; }
        return vacio / total;
      }
    }
    function revelaSinRascar() { var c = el.querySelector('canvas[data-cupon-rascar]'); if (c) c.classList.add('fuera'); el.classList.add('revelado'); }
    intenta();
  });
})();
